<script setup lang="ts">
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import { IconCheck } from '@icons';

interface InputTagProps {
  content: string;
  value: string;
  exponent?: string;
  active?: boolean;
}

const { active = false, exponent = '' } = defineProps<InputTagProps>();

defineEmits<{(e: 'update:tag', value: string): void }>();
</script>

<template>
  <button
    type="button"
    class="checkable-tag"
    :class="[
      'flex items-center justify-between',
      'h-10 w-full p-3',
      'rounded-lg',
      'hover:bg-gray-lighter',
      'cursor-pointer',
      'border border-solid border-gray',
      { '!border-blue !bg-blue-lighter': active }
    ]"
    @click.stop="$emit('update:tag', value)"
  >
    <Typography
      variant="small-title-tag"
      :color="active ? 'blue' : 'black'"
      class="!mr-4"
    >
      {{ content }}<sup v-if="exponent">{{ exponent }}</sup>
    </Typography>

    <Icon
      v-if="active"
      :svg="IconCheck"
      width="20"
      height="20"
      fill="blue"
    />

    <span v-else class="size-5" />
  </button>
</template>
